
export const demoStudentDashboard = {
  stats: {
    total_hours: 124,
    approved_logs: 12,
    pending_logs: 3,
    days_remaining: 14,
  },
  placement: {
    partner_name: "AzamPay Tanzania",
    hours_required: 300,
    status: "active",
  },
  recent_logs: [
    {
      id: "1",
      date: new Date().toISOString(),
      hours: 8,
      status: "approved",
      partner_name: "AzamPay",
      partnerName: "AzamPay",
      description: "Backend API implementation",
    },
    {
      id: "2",
      date: new Date(Date.now() - 86400000).toISOString(),
      hours: 7.5,
      status: "pending",
      partner_name: "AzamPay",
      partnerName: "AzamPay",
      description: "Frontend UI polishing",
    },
    {
      id: "3",
      date: new Date(Date.now() - 172800000).toISOString(),
      hours: 8,
      status: "approved",
      partner_name: "AzamPay",
      partnerName: "AzamPay",
      description: "Database optimization",
    },
  ],
  productivity: [
    { day: "Mon", hours: 8 },
    { day: "Tue", hours: 7 },
    { day: "Wed", hours: 9 },
    { day: "Thu", hours: 6 },
    { day: "Fri", hours: 8 },
    { day: "Sat", hours: 0 },
    { day: "Sun", hours: 0 },
  ],
};

export const demoPartnerDashboard = {
  kpis: {
    active_placements: 8,
    pending_reviews: 3,
    total_slots: 15,
  },
  pending_logs: [
    {
      id: "2",
      studentName: "Alice Johnson",
      student: "Alice Johnson",
      date: new Date().toISOString(),
      hours: 7,
      status: "pending",
      timeStart: "08:00",
      timeEnd: "16:00",
    },
  ],
  activity_trend: [
    { day: "Mon", logs: 4 },
    { day: "Tue", logs: 7 },
    { day: "Wed", logs: 5 },
    { day: "Thu", logs: 8 },
    { day: "Fri", logs: 6 },
  ],
  slot_data: [
    { name: "Filled", value: 8, color: "var(--chart-1)" },
    { name: "Available", value: 7, color: "var(--chart-2)" },
  ],
};

export const demoAdminDashboard = {
  total_students: 450,
  total_partners: 45,
  total_placements: 312,
  total_hours: 12500,
  pending_verifications: 28,
  growth: 12.5,
  trends: [
    { month: "Jan", students: 1200, partners: 140 },
    { month: "Feb", students: 1600, partners: 155 },
    { month: "Mar", students: 2100, partners: 172 },
    { month: "Apr", students: 2400, partners: 180 },
  ],
  distribution: [
    { name: "UDSM", count: 850 },
    { name: "Ardhi", count: 420 },
    { name: "IFM", count: 310 },
    { name: "TIA", count: 240 },
  ],
  recent_activities: [
    { text: "New student registration: Alice Johnson", time: "10 mins ago", type: "registration" },
    { text: "Partner onboarded: CRDB Bank", time: "2 hours ago", type: "partner" },
    { text: "Placement approved: Bob Smith at Tigo", time: "4 hours ago", type: "placement" },
    { text: "System backup completed", time: "6 hours ago", type: "system" },
  ],
  top_partners: [
    { id: 1, name: "AzamPay", industry: "Fintech", students: 45 },
    { id: 2, name: "Tigo Tanzania", industry: "Telecom", students: 32 },
    { id: 3, name: "CRDB Bank", industry: "Banking", students: 28 },
    { id: 4, name: "NMB Bank", industry: "Banking", students: 25 },
    { id: 5, name: "Vodacom", industry: "Telecom", students: 22 },
  ],
};

// Additional Data for sub-pages
export const demoWorkLogs = [
  {
    id: "1",
    date: "2026-04-20",
    hours: 8,
    description: "Backend API implementation",
    partnerName: "AzamPay",
    partner_name: "AzamPay",
    partner: "AzamPay",
    studentName: "Alice Johnson",
    student: "Alice Johnson",
    student_university: "UDSM",
    student_major: "Computer Science",
    student_year: 3,
    student_approved_logs: 12,
    student_reviewed_logs: 15,
    timeStart: "08:00",
    timeEnd: "16:00",
    status: "approved",
    feedback: "Great progress",
  },
  {
    id: "2",
    date: "2026-04-21",
    hours: 7,
    description: "Frontend UI polishing",
    partnerName: "AzamPay",
    partner_name: "AzamPay",
    partner: "AzamPay",
    studentName: "Alice Johnson",
    student: "Alice Johnson",
    student_university: "UDSM",
    student_major: "Computer Science",
    student_year: 3,
    student_approved_logs: 12,
    student_reviewed_logs: 15,
    timeStart: "08:30",
    timeEnd: "15:30",
    status: "pending",
    feedback: "",
  },
  {
    id: "3",
    date: "2026-04-22",
    hours: 8,
    description: "Database optimization",
    partnerName: "AzamPay",
    partner_name: "AzamPay",
    partner: "AzamPay",
    studentName: "Bob Smith",
    student: "Bob Smith",
    student_university: "UDSM",
    student_major: "Information Systems",
    student_year: 3,
    student_approved_logs: 5,
    student_reviewed_logs: 8,
    timeStart: "08:00",
    timeEnd: "16:00",
    status: "rejected",
    feedback: "Need more details",
  },
];

export const demoCourses = [
  {
    id: "1",
    title: "Industrial Training I",
    code: "CS 399",
    description: "Mandatory field training for CS students.",
    status: "enrolled",
    price: 0,
  },
  {
    id: "2",
    title: "Professionalism in IT",
    code: "IS 212",
    description: "Ethics and standards in industry.",
    status: "available",
    price: 50000,
  },
];

export const demoPlacements = [
  {
    id: "1",
    partner_name: "CRDB Bank",
    partnerName: "CRDB Bank",
    partner: "CRDB Bank",
    role: "Software Intern",
    period: "July - Sept 2026",
    status: "active",
  },
  {
    id: "2",
    partner_name: "Tigo Tanzania",
    partnerName: "Tigo Tanzania",
    partner: "Tigo Tanzania",
    role: "Network Assistant",
    period: "July - Sept 2026",
    status: "pending",
  },
];

export const demoStudents = [
  {
    id: "1",
    name: "Alice Johnson",
    student: "Alice Johnson",
    email: "alice.j@student.udsm.ac.tz",
    university: "UDSM",
    course: "Computer Science",
    year: "3",
    status: "active",
    verification_status: "verified",
    membership_tier: "verified",
    hoursLogged: 124,
    currentPlacement: "AzamPay Tanzania",
    skills: ["React", "TypeScript", "Node.js"],
    created_at: "2025-09-15T00:00:00Z",
    registeredDate: "2025-09-15T00:00:00Z",
    student_id_url: "dummy",
    resume_url: "dummy",
  },
  {
    id: "2",
    name: "Bob Smith",
    student: "Bob Smith",
    email: "b.smith@ifm.ac.tz",
    university: "IFM",
    course: "IT Management",
    year: "4",
    status: "pending",
    verification_status: "pending_review",
    membership_tier: "free",
    hoursLogged: 45,
    currentPlacement: "Tigo Tanzania",
    skills: ["Project Management", "Leadership"],
    created_at: "2025-08-20T00:00:00Z",
    registeredDate: "2025-08-20T00:00:00Z",
    dean_letter_url: "dummy",
  },
  {
    id: "3",
    name: "Charlie Msuya",
    student: "Charlie Msuya",
    email: "c.msuya@ardhi.ac.tz",
    university: "Ardhi",
    course: "Software Engineering",
    year: "2",
    status: "active",
    verification_status: "verified",
    membership_tier: "premium",
    hoursLogged: 82,
    currentPlacement: "CRDB Bank",
    skills: ["Python", "Django", "PostgreSQL"],
    created_at: "2025-10-01T00:00:00Z",
    registeredDate: "2025-10-01T00:00:00Z",
    student_id_url: "dummy",
  },
];

export const demoPartners = [
  { id: "1", user_id: "1", name: "AzamPay", industry: "Fintech", students: 12, status: "active" },
  { id: "2", user_id: "2", name: "Tigo Tanzania", industry: "Telecom", students: 8, status: "active" },
  { id: "3", user_id: "3", name: "CRDB Bank", industry: "Banking", students: 24, status: "pending" },
];

export const demoPlacementSlots = [
  {
    id: 1,
    title: "Software Engineer Intern",
    description: "Backend API development using Go and React",
    location: "Dar es Salaam",
    duration: "3 months",
    arrangement: "on-site",
    pac_allowed: false,
    max_students: 2,
    filled_slots: 1,
    partner_name: "CRDB Bank",
    status: "published",
  },
  {
    id: 2,
    title: "Internal Audit Intern",
    description: "Financial auditing and compliance monitoring",
    location: "Dar es Salaam",
    duration: "3 months",
    arrangement: "on-site",
    pac_allowed: false,
    max_students: 1,
    filled_slots: 0,
    partner_name: "NMB Bank",
    status: "published",
  },
  {
    id: 3,
    title: "Data Analyst Intern",
    description: "Business intelligence and data visualization",
    location: "Remote",
    duration: "3 months",
    arrangement: "remote",
    pac_allowed: true,
    pac_notes: "PAC students welcome",
    max_students: 2,
    filled_slots: 0,
    partner_name: "AzamPay",
    status: "published",
  },
  {
    id: 4,
    title: "Network Support Specialist",
    description: "IT infrastructure and network maintenance",
    location: "Dar es Salaam",
    duration: "3 months",
    arrangement: "on-site",
    pac_allowed: false,
    max_students: 1,
    filled_slots: 0,
    partner_name: "Tigo Tanzania",
    status: "published",
  },
];

export const demoAdminPlacements = [
  {
    id: "1",
    studentName: "Alice Johnson",
    student: "Alice Johnson",
    partnerName: "AzamPay",
    partner_name: "AzamPay",
    partner: "AzamPay",
    slot: "Software Engineer Intern",
    status: "active",
    hoursLogged: 240,
    hoursRequired: 400,
    startDate: "2026-06-01",
  },
  {
    id: "2",
    studentName: "Bob Smith",
    student: "Bob Smith",
    partnerName: "Tigo Tanzania",
    partner_name: "Tigo Tanzania",
    partner: "Tigo Tanzania",
    slot: "Network Analyst",
    status: "pending",
    hoursLogged: 0,
    hoursRequired: 400,
    startDate: "2026-06-01",
  },
];

export const demoNotifications = [
  {
    id: "1",
    title: "Log Approved",
    message: "Your work log for April 20th was approved.",
    time: "2 hours ago",
    unread: true,
  },
  {
    id: "2",
    title: "New Message",
    message: "AzamPay sent you a message regarding your CV.",
    time: "5 hours ago",
    unread: false,
  },
];

export const demoPayments = [
  {
    id: "1",
    student: "Alice Johnson",
    studentName: "Alice Johnson",
    amount: 150000,
    status: "completed",
    date: "2026-04-16",
    method: "M-Pesa",
  },
  {
    id: "2",
    student: "Bob Smith",
    studentName: "Bob Smith",
    amount: 150000,
    status: "pending",
    date: "2026-04-15",
    method: "Tigo Pesa",
  },
  {
    id: "3",
    student: "Charlie Msuya",
    studentName: "Charlie Msuya",
    amount: 150000,
    status: "completed",
    date: "2026-04-14",
    method: "Card",
  },
];

export const demoUsers = [
  {
    id: "1",
    name: "Alice Johnson",
    email: "alice.j@student.udsm.ac.tz",
    role: "Student",
    status: "active",
    joined: "2026-01-15",
  },
  {
    id: "2",
    name: "Bob Smith",
    email: "b.smith@ifm.ac.tz",
    role: "Student",
    status: "pending",
    joined: "2026-01-20",
  },
  {
    id: "3",
    name: "Charlie Msuya",
    email: "c.msuya@ardhi.ac.tz",
    role: "Student",
    status: "active",
    joined: "2026-02-01",
  },
  {
    id: "4",
    name: "AzamPay",
    email: "partner@azampay.co.tz",
    role: "Partner",
    status: "active",
    joined: "2026-01-10",
  },
  {
    id: "5",
    name: "Tigo Tanzania",
    email: "partner@tigo.co.tz",
    role: "Partner",
    status: "active",
    joined: "2026-01-12",
  },
];

export const demoAdminNotifications = [
  {
    id: "1",
    title: "System Update",
    message: "Platform maintenance scheduled for Sunday at 02:00 AM.",
    type: "system",
    recipients: "All Users",
    status: "sent",
    date: "2026-04-16",
  },
  {
    id: "2",
    title: "New Placement",
    message: "You have been assigned to CRDB Bank technical team.",
    type: "placement",
    recipients: "Alice Johnson",
    status: "sent",
    date: "2026-04-15",
  },
  {
    id: "3",
    title: "Payment Reminder",
    message: "Please complete your internship registration fee by Friday.",
    type: "payment",
    recipients: "Pending Students",
    status: "draft",
    date: "2026-04-15",
  },
];
